<div class="row mb-3" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/hourglass/tools'">
      <i class="fas fa-fw fa-lock me-2"></i>Admin Tools<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <i class="fas fa-fw fa-user-cog me-2"></i>Users Manager
  </div>
</div>

<div class="container-fluid py-3 users-page">
  <div class="d-flex align-items-center justify-content-between mb-3 users-toolbar">
    <div class="mb-0 c_bluedk module_title">
      <i class="fas fa-fw fa-user-cog me-2"></i>Users Manager
    </div>

    <div class="d-flex gap-2 align-items-center">
      <!-- Toggle -->
      <div class="btn-group btn-group-sm" role="group" aria-label="Active toggle">
        <button
          type="button"
          class="btn"
          [class.btn-dark]="view === 'active'"
          [class.btn-light]="view !== 'active'"
          (click)="setView('active')">
          Active
        </button>
        <button
          type="button"
          class="btn"
          [class.btn-dark]="view === 'inactive'"
          [class.btn-light]="view !== 'inactive'"
          (click)="setView('inactive')">
          Inactive
        </button>
      </div>

      <button type="button" class="btn btn-primary btn-sm" (click)="openCreate()">
        <i class="fas fa-plus me-1"></i>
        Add User
      </button>

      <button type="button" class="btn btn-light btn-sm" (click)="loadUsers()">
        <i class="fas fa-sync-alt me-1"></i>
        Refresh
      </button>
    </div>
  </div>

  <div class="grid_sizer">
    <ag-grid-angular
      class="ag-theme-alpine"
      style="width:100%; height:100%; border:0 !important"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowHeight]="28"
      [headerHeight]="32"
      [pagination]="true"
      [paginationAutoPageSize]="true"
      (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)">
    </ag-grid-angular>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger mt-3">{{ errorMessage }}</div>
  <div *ngIf="loading" class="mt-3 text-muted">Loading…</div>
</div>

<!-- Modal -->
<div class="modal fade" id="usersEditorModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">

      <div class="modal-header">
        <h6 class="modal-title">
          <i class="fas fa-user-edit me-2"></i>
          {{ isEditing ? 'Edit User' : 'Add User' }}
        </h6>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
      </div>

      <div class="modal-body">
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">First Name</label>
            <input class="form-control" [(ngModel)]="editor.f_name" />
          </div>

          <div class="col-md-4">
            <label class="form-label">Middle Name</label>
            <input class="form-control" [(ngModel)]="editor.m_name" />
          </div>

          <div class="col-md-4">
            <label class="form-label">Last Name</label>
            <input class="form-control" [(ngModel)]="editor.l_name" />
          </div>

          <div class="col-md-6">
            <label class="form-label">Work Email</label>
            <input class="form-control" [(ngModel)]="editor.w_email" />
          </div>

          <div class="col-md-6">
            <label class="form-label">Personal Email</label>
            <input class="form-control" [(ngModel)]="editor.p_email" />
          </div>

          <div class="col-md-4">
            <label class="form-label">Role</label>
            <input type="number" class="form-control" [(ngModel)]="editor.role" />
          </div>

          <div class="col-md-4">
            <label class="form-label">Admin</label>
            <select class="form-select" [(ngModel)]="editor.admin">
              <option [ngValue]="0">0</option>
              <option [ngValue]="1">1</option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label">Create Task</label>
            <select class="form-select" [(ngModel)]="editor.create_task">
              <option [ngValue]="0">0</option>
              <option [ngValue]="1">1</option>
            </select>
          </div>

          <div class="col-md-12">
            <label class="form-label">Title</label>
            <input class="form-control" [(ngModel)]="editor.title" />
          </div>

          <div class="col-md-12">
            <label class="form-label">LinkedIn</label>
            <input class="form-control" [(ngModel)]="editor.linkedin_link" />
          </div>

          <div class="col-md-4">
            <label class="form-label">Active</label>
            <select class="form-select" [(ngModel)]="editor.active">
              <option [ngValue]="1">1</option>
              <option [ngValue]="0">0</option>
            </select>
          </div>

          <div class="col-md-8">
            <label class="form-label">Old Name</label>
            <input class="form-control" [(ngModel)]="editor.old_name" />
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-light btn-sm" (click)="closeModal()">Close</button>
        <button class="btn btn-dark btn-sm" (click)="save()">
          <i class="fas fa-save me-1"></i>Save
        </button>
      </div>

    </div>
  </div>
</div>
